import React from "react";
import { Droplets, Activity, GitBranch, ShieldCheck, Beaker, Thermometer } from "lucide-react";

export default function Technical() {
  const protocols = [
    {
      icon: <Beaker size={20} />,
      title: "Scientific Feeding",
      desc: "Custom TMR formulated for specific life stages, ensuring optimum Average Daily Gain (ADG).",
      color: "text-[#D4AF37]"
    },
    {
      icon: <Activity size={20} />,
      title: "Health Monitoring",
      desc: "Bi-weekly biometric assessments and rigorous screening for PPR, ET, and Blue Tongue.",
      color: "text-[#2D5A27]"
    },
    {
      icon: <GitBranch size={20} />,
      title: "Controlled Breeding",
      desc: "Line-breeding protocols strictly managed to prevent inbreeding and enhance vigor.",
      color: "text-[#D4AF37]"
    },
    {
      icon: <ShieldCheck size={20} />,
      title: "Bio-Security",
      desc: "Closed-herd management with strict quarantine and medical-grade sanitation.",
      color: "text-[#2D5A27]"
    }
  ];

  return (
    <div className="bg-[#FDFCF8] py-12">
      <div className="max-w-7xl mx-auto px-6">
        
        <div className="flex flex-col lg:flex-row justify-between items-end mb-10 gap-6">
          <div className="max-w-xl">
            <span className="text-[9px] font-black uppercase tracking-[0.5em] text-[#D4AF37] block mb-2">
              Research Parameters
            </span>
            <h2 className="text-3xl font-black text-[#4B3621] tracking-tighter leading-tight">
              Operational <span className="text-[#2D5A27]">Protocols.</span>
            </h2>
          </div>
          <p className="text-gray-500 font-medium max-w-sm text-[11px] leading-relaxed">
            Our facility operates under ISO-inspired agricultural standards to ensure 
            maximum biological security and genetic integrity.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-gray-100 border border-gray-100 rounded-2xl overflow-hidden shadow-lg">
          {protocols.map((item, i) => (
            <div key={i} className="bg-white p-8 hover:bg-[#FDFCF8] transition-colors group">
              <div className={`${item.color} mb-4 transition-transform duration-500 group-hover:scale-110`}>
                {item.icon}
              </div>
              <h3 className="text-base font-black text-[#4B3621] uppercase tracking-tight mb-2">
                {item.title}
              </h3>
              <p className="text-gray-500 text-[12px] leading-relaxed font-medium">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { label: "Water Quality", value: "RO Filtered" },
            { label: "Ventilation", value: "Natural/Cross" },
            { label: "Record Keeping", value: "Digital/RFID" },
            { label: "Sanitation", value: "Daily Cycle" }
          ].map((stat, i) => (
            <div key={i} className="border-l-2 border-[#D4AF37] pl-4">
              <p className="text-[8px] font-black text-gray-400 uppercase tracking-widest mb-0.5">{stat.label}</p>
              <p className="text-[12px] font-bold text-[#4B3621]">{stat.value}</p>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}